import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { BasicTextBox } from '../../shared/basicTextBox';

export interface AddProgramPanelProps {
	onCreate: (name: string) => void;
}

export function AddProgramPanel({ onCreate }: AddProgramPanelProps) {
	const [newProgramName, setNewProgramName] = useState<string>('');

	function newFormContent() {
		return (
			<Box>
				<Box>
					<BasicTextBox
						id="txtName"
						label="Program Name"
						maxLength={50}
						width={275}
						value={newProgramName}
						onChange={(e) => setNewProgramName(e.target.value)}
					/>
				</Box>
				<Box>
					<Button
						variant="contained"
						color="primary"
						onClick={() => {
							onCreate(newProgramName);
						}}
					>
						Create Program
					</Button>
				</Box>
			</Box>
		);
	}

	return (
		<div>
			<h2>Add Custom Program</h2>
			{newFormContent()}
		</div>
	);
}
